module.exports = __webpack_public_path__ + "0a2f962b0c95df53eb28c39cda378e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/coh_image_1.jpg
// module id = 495
// module chunks = 0